// Shared, site-wide constants.

// Public link to Noah's resume (Google Drive).
export const RESUME_URL =
    'https://drive.google.com/file/d/1DkaFCQA37sctRtrEZd25FE4KuGogT9Fc/view?usp=sharing';
